import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotVideos from './components/HotVideos';
import StatsSection from './components/StatsSection';
import DownloadCTA from './components/DownloadCTA';
import { categoryVideos } from '@/mocks/categories';

const hotVideos = (categoryVideos['搞笑'] || []).slice(0, 4);
const trendingVideos = (categoryVideos['音乐'] || []).slice(0, 4);
const recommendVideos = (categoryVideos['知识'] || []).slice(0, 4);

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '红桃视频',
    url: 'https://hongtaovideo.com',
    description: '红桃视频是一款备受用户喜爱的高清短视频平台，提供海量精彩内容、流畅播放体验与个性化推荐。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hongtaovideo.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '红桃视频',
    url: 'https://hongtaovideo.com',
    description: '中国领先的高清短视频平台',
    foundingDate: '2019',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="红桃视频-高清短视频平台官方入口 | 畅享无限视频娱乐"
        description="红桃视频是一款备受用户喜爱的高清短视频平台，提供海量精彩内容、流畅播放体验与个性化推荐。立即访问红桃视频官方入口，畅享无限视频娱乐，随时随地发现热门内容。"
        keywords="红桃视频,红桃视频官网,红桃视频下载,红桃视频APP,红桃视频最新版,红桃视频入口,红桃视频在线观看"
        canonicalUrl="https://hongtaovideo.com"
        ogImage="https://readdy.ai/api/search-image?query=warm%20coral%20and%20amber%20gradient%20abstract%20background%20with%20modern%20minimalist%20style%2C%20digital%20art%2C%20clean%20composition%2C%20no%20text%20no%20logos&width=1200&height=630&seq=og-home&orientation=landscape"
        jsonLd={{ ...jsonLd, ...orgJsonLd }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <HotVideos
          title="热门搞笑视频"
          subtitle="全网最火的搞笑内容，让你开心每一天"
          videos={hotVideos}
          viewAllLink="/category/搞笑"
        />
        <StatsSection />
        <HotVideos
          title="热门音乐视频"
          subtitle="好音乐，听不够"
          videos={trendingVideos}
          viewAllLink="/category/音乐"
        />
        <HotVideos
          title="知识科普推荐"
          subtitle="每天学点新知识"
          videos={recommendVideos}
          viewAllLink="/category/知识"
        />
        <DownloadCTA />
      </main>

      <Footer />
    </>
  );
}